import { named, withDependencies } from '@wix/thunderbolt-ioc'
import { IFontsLoadingState, IFontsStatusNotifier, ViewerManagerFontsApiEditorConfig } from './types'
import _ from 'lodash'
import { EditorFeatureConfigSymbol } from '@wix/thunderbolt-symbols'
import { FontsLoadingStateSymbol, name } from './symbols'

export const FontsStatusNotifier = withDependencies(
	[named(EditorFeatureConfigSymbol, name), FontsLoadingStateSymbol],
	(config: ViewerManagerFontsApiEditorConfig, featureState: IFontsLoadingState): IFontsStatusNotifier => {
		const subscribers: Array<() => void> = [() => {}]

		const notifyFontStatusChange = () => {
			subscribers.forEach((cb) => cb())
		}

		const getPendingFonts = () =>
			_.filter(
				config.usedFonts,
				(fontFamily) =>
					!_.get(featureState.get(), ['loadedFonts', fontFamily]) &&
					!_.get(featureState.get(), ['timedOutFonts', fontFamily])
			)

		return {
			hasPendingFonts: () => !_.isEmpty(getPendingFonts()),
			registerToFontsLoadingStatus: (cb) => {
				subscribers.push(cb)
			},
			notifyFontStatusChange,
		}
	}
)
